import { render, staticRenderFns } from "./copyProject.vue?vue&type=template&id=1f9acbde&scoped=true&"
import script from "./copyProject.vue?vue&type=script&lang=js&"
export * from "./copyProject.vue?vue&type=script&lang=js&"
import style0 from "./copyProject.vue?vue&type=style&index=0&id=1f9acbde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9acbde",
  null
  
)

export default component.exports